import {ReactNode} from 'react';

export enum SortingOptionsValues {
    asc = 'asc',
    desc = 'desc',
}

export interface Sort {
    sortBy?: string;
    sortOrder?: SortingOptionsValues;
}

export type handleSortFn = (sort: Sort) => void;
export type SetPage = (value: number) => void;
export type SetRowsPerPage = (value: number) => void;
export type SetSort = (newSort: Sort) => void;
export type OnChangePageHandler = () => void;
export type JSXStr = string | JSX.Element;

export interface ColumnType {
    dataKey?: string;
    width?: number;
    title?: JSXStr;
    render?: (row: any) => ReactNode;
    sortable?: boolean;
}

export interface PagingParams {
    limit: number;
    offset: number;
}

export enum TableVariants {
    dark = 'dark',
    scrollable = 'scrollable',
}
